module.exports = __webpack_public_path__ + "static/img/OscarPiastri.22eadd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OscarPiastri.jpg
// module id = NpkY
// module chunks = 0